/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { RegistrySearchItem } from './RegistrySearchItem'
import {
  RegistrySearchItemFromJSON,
  RegistrySearchItemFromJSONTyped,
  RegistrySearchItemToJSON,
} from './RegistrySearchItem'

/**
 *
 * @export
 * @interface RegistryImageSearch200ResponseData
 */
export interface RegistryImageSearch200ResponseData {
  /**
   * Найденные знаки и заявки
   * @type {Array<RegistrySearchItem>}
   * @memberof RegistryImageSearch200ResponseData
   */
  items: Array<RegistrySearchItem>
  /**
   * Зашифрованный идентификатор поиска для пагинации следующих страниц
   * @type {string}
   * @memberof RegistryImageSearch200ResponseData
   */
  searchId: string
}

/**
 * Check if a given object implements the RegistryImageSearch200ResponseData interface.
 */
export function instanceOfRegistryImageSearch200ResponseData(
  value: object
): value is RegistryImageSearch200ResponseData {
  if (!('items' in value) || value['items'] === undefined) return false
  if (!('searchId' in value) || value['searchId'] === undefined) return false
  return true
}

export function RegistryImageSearch200ResponseDataFromJSON(
  json: any
): RegistryImageSearch200ResponseData {
  return RegistryImageSearch200ResponseDataFromJSONTyped(json, false)
}

export function RegistryImageSearch200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryImageSearch200ResponseData {
  if (json == null) {
    return json
  }
  return {
    items: (json['items'] as Array<any>).map(RegistrySearchItemFromJSON),
    searchId: json['searchId'],
  }
}

export function RegistryImageSearch200ResponseDataToJSON(
  value?: RegistryImageSearch200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    items: (value['items'] as Array<any>).map(RegistrySearchItemToJSON),
    searchId: value['searchId'],
  }
}
